import axios from 'axios';
import { IDataTableQueryFnParams } from 'src/components/DataTable/shared/types';
import { vendorUrlRegexPath, withPimURL } from 'src/helpers/service';
import { FlashDiscountProductListResponse } from '../models/flash-discount';

export const getFlashDiscountProductsQueryKey = () => {
  return ['flash-discount-products'];
};

export const getFlashDiscountProducts = async (params: IDataTableQueryFnParams) => {
  const { filters, pagination } = params;

  return axios
    .get<FlashDiscountProductListResponse>(withPimURL(vendorUrlRegexPath('/flash-discount/:vendorId/products')), {
      params: {
        ...filters,
        page: pagination.pageIndex,
        limit: pagination.pageSize,
      },
    })
    .then((res) => res.data)
    .then((res) => ({
      ...res,
      items: res.items.map((item) => ({
        ...item,
        _rowId: `flash-discount-product-${item.id}${Array.isArray(item.periodInfo) ? item.periodInfo?.map((e: any) => e.id).join('-') : ''}`,
      })),
    }));
};
